namespace $ {
	export class $gen_app_user extends $mol_page {
		
		/**
		 * ```tree
		 * title \⚙️
		 * ```
		 */
		title() {
			return "⚙️"
		}
		
		/**
		 * ```tree
		 * user? $gen_engine_user
		 * ```
		 */
		@ $mol_mem
		user(next?: any) {
			if ( next !== undefined ) return next as never
			const obj = new this.$.$gen_engine_user()
			
			return obj
		}
		
		/**
		 * ```tree
		 * body /
		 * 	<= Login_labeler
		 * 	<= Name_labeler
		 * 	<= Email_labeler
		 * 	<= Heroes_length_labeler
		 * 	<= Logout
		 * ```
		 */
		body() {
			return [
				this.Login_labeler(),
				this.Name_labeler(),
				this.Email_labeler(),
				this.Heroes_length_labeler(),
				this.Logout()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * login \sad
		 * ```
		 */
		login() {
			return "sad"
		}
		
		/**
		 * ```tree
		 * Login $mol_paragraph title <= login
		 * ```
		 */
		@ $mol_mem
		Login() {
			const obj = new this.$.$mol_paragraph()
			
			obj.title = () => this.login()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Login_labeler $mol_labeler
		 * 	title \Логин
		 * 	content / <= Login
		 * ```
		 */
		@ $mol_mem
		Login_labeler() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => "Логин"
			obj.content = () => [
				this.Login()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * name? \Имя
		 * ```
		 */
		@ $mol_mem
		name(next?: any) {
			if ( next !== undefined ) return next as never
			return "Имя"
		}
		
		/**
		 * ```tree
		 * Name $mol_string value? <=> name?
		 * ```
		 */
		@ $mol_mem
		Name() {
			const obj = new this.$.$mol_string()
			
			obj.value = (next?: any) => this.name(next)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Name_labeler $mol_labeler
		 * 	title \Имя
		 * 	content / <= Name
		 * ```
		 */
		@ $mol_mem
		Name_labeler() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => "Имя"
			obj.content = () => [
				this.Name()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * email \Email
		 * ```
		 */
		email() {
			return "Email"
		}
		
		/**
		 * ```tree
		 * Email $mol_paragraph title <= email
		 * ```
		 */
		@ $mol_mem
		Email() {
			const obj = new this.$.$mol_paragraph()
			
			obj.title = () => this.email()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Email_labeler $mol_labeler
		 * 	title \Email
		 * 	content / <= Email
		 * ```
		 */
		@ $mol_mem
		Email_labeler() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => "Email"
			obj.content = () => [
				this.Email()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * heroes_length \0
		 * ```
		 */
		heroes_length() {
			return "0"
		}
		
		/**
		 * ```tree
		 * Heroes_length $mol_paragraph title <= heroes_length
		 * ```
		 */
		@ $mol_mem
		Heroes_length() {
			const obj = new this.$.$mol_paragraph()
			
			obj.title = () => this.heroes_length()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Heroes_length_labeler $mol_labeler
		 * 	title \Кол-во героев
		 * 	content / <= Heroes_length
		 * ```
		 */
		@ $mol_mem
		Heroes_length_labeler() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => "Кол-во героев"
			obj.content = () => [
				this.Heroes_length()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * logout? null
		 * ```
		 */
		@ $mol_mem
		logout(next?: any) {
			if ( next !== undefined ) return next as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Logout $mol_button_major
		 * 	title \Выйти
		 * 	click? <=> logout?
		 * ```
		 */
		@ $mol_mem
		Logout() {
			const obj = new this.$.$mol_button_major()
			
			obj.title = () => "Выйти"
			obj.click = (next?: any) => this.logout(next)
			
			return obj
		}
	}
	
}

